<template>
  <div class="create row flex">
    <div class="profileImg">
      <div class="col-xs-12" style="padding:0;">
        <kr-file-picture
          :form="form"
          name="avatar"
          :options="{ width: '200', height: '200' }"
        ></kr-file-picture>
      </div>
    </div>
    <div class="col-xs-12 col-md-6">
      <div class="col-xs-12 flex">
        <div class="col-xs-12 col-md-6">
          <kr-field
            display="First Name"
            :form="form"
            name="firstname"
            ariaLabel="first name"
            :options="{ placeholder: 'Enter first name', required: true }"
          ></kr-field>
        </div>
        <div class="col-xs-12 col-md-6">
          <kr-field
            display="Last Name"
            :form="form"
            name="lastname"
            ariaLabel="last name"
            :options="{ placeholder: 'Enter last name', required: isLastNameRequired }"
          ></kr-field>
        </div>
      </div>
      <div v-if="[2,3].includes(auth.user().roleId)" class="col-xs-12 flex">
        <div class="col-xs-12 col-md-6">
          <kr-field
            display="Job Title"
            :form="form"
            name="jobTitle"
            ariaLabel="job title"
            :options="{ placeholder: 'Enter job title' }"
          ></kr-field>
        </div>
        <div class="col-xs-12 col-md-6">
          <kr-select
            class="no-error"
            display="Academic Discipline"
            name="academicDiscipline"
            :form="form"
            :items="kr_var.academicDisciplines"
            item_value_idx="value"
            item_desc_idx="description"
          >
            <template slot="option" slot-scope="props">
              <template v-for="option in props.model" >
                <option :key="option.value" :value="option.value"
                  >
                  {{ option.description }}
                  </option
                >
              </template>
            </template>
          </kr-select>
        </div>
      </div>
      <div v-if="form.model.email">
        <div class="form-group">
          <label class="control-label">Email</label>
          <p class="form-control-static">{{ form.model.email }}</p>
        </div>
      </div>
      <div
        v-if="
          user.role != 'Student' || (user.role == 'Student' && form.model.email)
        "
      >
        <kr-change-password :form="form"></kr-change-password>
      </div>

      <div class="form-group">
        <label class="control-label">
          Highlight Color
        </label>
        <br />
        <template v-if="colorPicked == '#17244A'">
          <p :style="`background-color: ${colorPicked} ; color: #fff; display: inline-block;`">
            <b>Example: </b> <i>This is highlighted text</i>
          </p>
        </template>
        <template v-else>
          <p :style="`background-color: ${colorPicked} ; color: #222; display: inline-block;`">
            <b>Example: </b> <i>This is highlighted text</i>
          </p>
        </template>

        <div class="flex">
          <div v-for="(color, idx) in colors" class="radioField colorPicker margin10" :key="`${idx}-${color}`">
                <input type="radio" name="color-picker" :id="`colorPicker-${idx}`" :style="'background:'+ color" v-model="colorPicked" :value="color"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import KrAuth from "./../../../../components/auth/auth";
export default {
  props: ["form", "colorPick"],
  data() {
    var auth = new KrAuth();
    return {
      auth: auth,
      user: auth.user(),
      isLastNameRequired: true,
      colors: ["#FFF5BD", "#E2E2E2", "#E4E1FF", "#FFCFCF", "#FFFF00", "#2FFF2F", "#17244A", "#00FEFE", "#b5b5b5"],
      colorPicked: null,
    };
  },
  created() {
    if (this.form.model.email == null) {
      this.isLastNameRequired = false;
    }

    if (window.localStorage.getItem("highlightColor") == null) {
      this.colorPicked = "#b5b5b5";
    } else {
      this.colorPicked = window.localStorage.getItem("highlightColor");
    }
  },
  methods: {
    emitSelectedValue() {
      this.$emit("selected", this.colorPicked);
    }
  },
  watch: {
    colorPicked() {
      this.emitSelectedValue();
    }
  }
};
</script>

<style scoped lang="scss">
.colorPicker {
  input[type="radio"] {
    width:42px;
    height: 42px;
    border-radius: 8px;

    &:checked {
      border: 3px solid #761fbb;
      box-shadow: none;
    }

    &:focus-visible {
      outline-offset: 3px;
      outline: 4px solid #1941a6;
      box-shadow: none;
    }
  }
}
</style>
